module.exports = __webpack_public_path__ + "img/dark-green-circle-table-5.45dadf97.png";